// extracted by mini-css-extract-plugin
export default {"block":"subscription_block__u97mN"};